<template lang='pug'>
//- 改版提示區塊
div(:class='$style[`cc-popbox-pwa`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(v-if='!showTutorial' :class='$style[`cc-content-left-wrap`]')
    span(:class='$style[`cc-left-wrap-title`]')
      span.font-bold 教您
      span.font-bold.font-doctor-theme.no-wrap 兩步驟
      span.font-bold 使用
      span.font-bold.font-normal-theme.no-wrap 更方便

    div(:class='$style[`cc-content-main-wrap`]')
      div(:class='$style[`cc-pwa-choose`]')
        div.font-medium(:class='$style[`cc-pwa-choose-title`]') 您使用的裝置？
        div(:class='$style[`cc-pwa-choose-platform`]')
          button.font-bold.btn-extra(
            aria-label='查看iOS教學'
            tabindex='0'
            :class='$style[`cc-platform-ios`]'
            @click='handleClickChoosePlatform(`ios`)')
            IconIos(:size='26' :color='`#262626`')
            span Apple iOS

          button.font-bold.btn-extra(
            aria-label='查看Android教學'
            tabindex='0'
            :class='$style[`cc-platform-android`]'
            @click='handleClickChoosePlatform(`android`)')
            IconAndroid(:size='26' :color='`#262626`')
            span Android

  div(v-else :class='$style[`cc-pwa-tutorial`]')
    //- Apple iOS
    ul(v-if='platformType === `ios`' :class='$style[`cc-pwa-tutorial-ios`]')
      li(:class='$style[`cc-pwa-tutorial-li`]')
        span.font-medium 1. 使用
        strong.font-bold 【Safari瀏覽器】
        span.font-medium 開啟首頁。(
        a.font-medium.font-doctor-theme(href='https://cancell.ai') https://cancell.ai/
        span.font-medium )
      li(:class='$style[`cc-pwa-tutorial-li`]')
        span.font-medium 2. 於任何頁面下，點選下方
        strong.font-bold 【分享按鈕】
        span.font-medium ，如下圖。
        figure
          img(:src='`${STATIC_URL}images/news/ios/step1.webp`' width='100%')
      li(:class='$style[`cc-pwa-tutorial-li`]')
        span.font-medium 3. 選擇
        strong.font-bold 【加入主畫面】
        span.font-medium 並確認新增，如下圖。
        figure
          img(:src='`${STATIC_URL}images/news/ios/step2.webp`' width='100%')
      li(:class='$style[`cc-pwa-tutorial-li`]')
        span.font-medium 4. 未來點選桌面上APP圖示即可快速開啟Cancell。
        figure
          img(:src='`${STATIC_URL}images/news/ios/step3.webp`' width='100%')

    //- Google Android
    ul(v-else :class='$style[`cc-pwa-tutorial-android`]')
      li(:class='$style[`cc-pwa-tutorial-li`]')
        span.font-medium 1. 使用
        strong.font-bold 【Chrome瀏覽器】
        span.font-medium 開啟首頁。(
        a.font-medium.font-doctor-theme(href='https://cancell.ai') https://cancell.ai/
        span.font-medium )
      li(:class='$style[`cc-pwa-tutorial-li`]')
        span.font-medium 2. 於任何頁面下，點選右上方
        strong.font-bold 【更多按鈕】
        span.font-medium ，如下圖。
        figure
          img(:src='`${STATIC_URL}images/news/android/step1.webp`' width='100%')
      li(:class='$style[`cc-pwa-tutorial-li`]')
        span.font-medium 3. 選擇
        strong.font-bold 【加入主畫面】
        span.font-medium 並確認新增，如下圖。
        figure
          img(:src='`${STATIC_URL}images/news/android/step2.webp`' width='100%')
      li(:class='$style[`cc-pwa-tutorial-li`]')
        span.font-medium 4. 未來點選桌面上APP圖示即可快速開啟Cancell。
        figure
          img(:src='`${STATIC_URL}images/news/android/step3.webp`' width='100%')

    div(:class='$style[`cc-content-pwa-controller`]')
      button.btn-extra.font-medium(
        aria-label='返回'
        tabindex='0'
        :class='$style[`cc-pwa-controller-btn`]'
        @click='handleClickToReturn') 返回

    //- div.font-regular(:class='$style[`cc-swiper-pagination`]')
    //-   span {{ `${currentIndex + 1} / ${totalIndex}` }}

    //- div(:class='$style[`cc-swiper-close-read`]')
    //-   div(:class='$style[`cc-swiper-close-read-btn`]' @click='handleClickNewIsRead')!= '不再顯示'

    //- div(:class='$style[`cc-pwa-swiper`]')
    //-   ul(:class='$style[`cc-pwa-swiper-ul`]')
    //-     li(:class='$style[`cc-pwa-swiper-list`]')
    //-       div(:class='$style[`cc-swiper-lower`]')
    //-         span.font-medium(:class='$style[`cc-swiper-lower-info`]')!= 'Cancell開發團隊與LineBot做資料結合，不用登入Cancell 醫抗癌即可瀏覽所有資訊，立即加入Cancell醫抗癌Line官方帳號吧。'
    //-       div(:class='$style[`cc-swiper-controller`]')
    //-         a(href='https://lin.ee/eEea6j5')
    //-           img(src='https://scdn.line-apps.com/n/line_add_friends/btn/zh-Hant.png' alt='加入好友' height='36' border='0')

</template>

<script>
import { mapMutations } from 'vuex';
import IconIos from '../../icon/Ios';
import IconAndroid from '../../icon/Android';

export default {
  components: {
    IconIos,
    IconAndroid,
  },

  data() {
    return {
      showTutorial: false,
      platformType: '', // android & ios
    };
  },

  methods: {
    ...mapMutations({
      changePopShowTutorialStatus: 'global/POPSHOW_TUTORIAL_STATUS',
    }),

    handleClosePopBox() {
      this.changePopShowTutorialStatus({
        active: false,
        include: '',
      });
    },

    handleClickToReturn() {
      this.platformType = '';
      this.showTutorial = false;
    },

    handleClickChoosePlatform(type) {
      this.platformType = type;
      this.showTutorial = true;
    },
  },

  // eslint-disable-next-line vue/order-in-components
  // computed: {
  //   ...mapGetters({
  //     loginDjangoId: 'user/exportUserDjangoId',
  //     loginStatus: 'user/exportLoginStatus',
  //     loginProfile: 'user/exportUserProfile',
  //   }),
  // },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/PopHowToSetPwa.scss';
</style>
